import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IConfig } from 'src/app/_interfaces/IConfig.types';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  apiBaseUrl = environment.apiBaseUrl;
  private configSubject: BehaviorSubject<IConfig>;
  public configObservable: Observable<IConfig>;

  constructor(
    private _httpClient: HttpClient,
  ) {
    const localConfig = localStorage.getItem('config');
    const config = localConfig ? JSON.parse(localConfig) : {};
    this.configSubject = new BehaviorSubject<IConfig>(config);
    this.configObservable = this.configSubject.asObservable();
  }

  set config(config: IConfig) {

    this.configSubject.next(config);

    localStorage.setItem('config', JSON.stringify(config));
    
  }

  get config(): IConfig {
    let config = this.configSubject.value;
    if(!config) {
      const localConfig = localStorage.getItem('config') ?? '';
      config = localConfig ? JSON.parse(localConfig) : null;
    }
    return config;
  }

  get() {
    return this._httpClient.get(`${this.apiBaseUrl}/configs`).pipe(
      switchMap((response: any) => {
        const { isSuccess, data } = response;
        if(isSuccess) {

          // Store the access token in the local storage
          this.config = data;

          // Return a new observable with the response
          return of(response);
        } else {
          return of(response);
        }
      })
    );
  }

  create(params: { key: string, data: [ any ] }) {
    return this._httpClient.post(`${this.apiBaseUrl}/configs`, params);
  }
}
